import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-connect-feed-dialog',
  templateUrl: './connect-feed-dialog.component.html',
  styleUrls: ['./connect-feed-dialog.component.scss'],
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule]
})
export class ConnectFeedDialogComponent {

  external_account_id = '';
  target_country = 'CA';
  language = 'en';
  currency = 'CAD';
  website = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConnectFeedDialogComponent>
  ) { }

  save() {
    this.dialogRef.close({
      tenant_id: this.data.tenantId,
      destination_code: this.data.destination.code,
      external_account_id: this.external_account_id,
      external_settings: {
        target_country: this.target_country,
        language: this.language,
        currency: this.currency,
        website: this.website
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
